/* eslint-disable import/first */
import React from 'react';
import { useNavigate } from '@reach/router';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
import { RiUserAddLine } from '@react-icons/all-files/ri/RiUserAddLine';
import Grid from '@material-ui/core/Grid';
const { useSelector, useDispatch } = Redux;
import { Button } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { FiPhone } from '@react-icons/all-files/fi/FiPhone';
const { selectDesktop } = Slices.appSlice;
import { numberWithSpaces } from 'spwa-ui-library/esm/utils/helper';
import css from './index.module.scss';

const ProfileCard = ({ name, phone, cCode, onChange }) => {
  // const navigate = useNavigate();
  // eslint:fix
  const isDesktop = useSelector(selectDesktop);

  return (
    <div className={css.section}>
      <div className={css.editProfile}>
        {!isDesktop && (
          <Grid className={css.circleArea1}>{name.toUpperCase()[0] || <RiUserAddLine />}</Grid>
        )}
        <div className={css.profileName}>
          {name}
          <span className={css.mobileArea}>
            {isDesktop && (
              <span className={css.mobileIcon}>
                <FiPhone />
              </span>
            )}
            <span className={css.mobileNumber}>
              {cCode} - {numberWithSpaces(phone, '### ### ### ###')}
            </span>
          </span>
        </div>
        <Button
          variant="outlined"
          color="secondary"
          className={css.profileCardChange}
          onClick={onChange}
        >
          <FormattedMessage id="checkout_change" defaultMessage="Change" />
        </Button>
      </div>
    </div>
  );
};

export default ProfileCard;
